import CoreBase from '../../services/engines/CoreBase';

class TestDlgSaver extends CoreBase {
    _name = 'TestDlgSaver';

    save = async (inputs) => {
        try {
            // TODO: implement
            this.logDebug('save', JSON.stringify(inputs));
        } catch (error) {
            this.logError('save', error.message);
        }
    };
}

const testDlgSaver = new TestDlgSaver();
export default testDlgSaver;
